import React, { useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { useMsal } from '@azure/msal-react';
import moment from "moment";
import { archiveBackupItem } from "../../_helpers/api";

const ArchiveModal = (props) => {
  const { accounts } = useMsal();
  const [archiveReason, setArchiveReason] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    setSubmitting(true);
    setError(null);
    try {
      await archiveBackupItem(props.item._id, archiveReason, accounts[0]?.username);
      console.log('Archive submitted:', {
        item: props.item,
        reason: archiveReason,
        user: accounts[0]?.username,
        timestamp: moment().format("DD.MM.YYYY HH:mm:ss")
      });
      setArchiveReason("");
      props.handleClose();
      if (props.onSuccess) {
        props.onSuccess();
      }
    } catch (err) {
      console.error('Error archiving backup item:', err);
      setError(err.response?.data?.error || err.message || 'Failed to archive item');
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    setArchiveReason("");
    props.handleClose();
  };

  return (
    <Modal show={props.show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Backup Item archivieren</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Bist du sicher? 👮</Form.Label>
          <Form.Control 
            as="textarea" 
            rows={3} 
            value={archiveReason}
            onChange={(e) => setArchiveReason(e.target.value)}
            placeholder="Gib hier den Grund für die Archivierung ein..."
            disabled={submitting}
          />
        </Form.Group>
        {error && <div className="alert alert-danger mt-2">{error}</div>}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <div className="text-muted small">
          <div>{accounts[0]?.username}, {moment().format("DD.MM.YYYY HH:mm:ss")}</div>
          <div>Id: {props.item?._id}</div>
        </div>
        <Button variant="primary" onClick={handleSubmit} disabled={!archiveReason.trim() || submitting}>
          {submitting ? <><Spinner animation="border" size="sm" /> Archivierung...</> : 'Absenden'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ArchiveModal;
